import * as actions from './contact.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store} from '@ngrx/store';
import { ContactModel } from '@smarttask-common/src/lib/models/Record/Contact/Core/ContactModel';

export const contactAdapter = createEntityAdapter<ContactModel>({
  selectId: x => x.record_id
});
export interface ContactState extends EntityState<ContactModel>{
  selected_record_id: string
};

export const initialState: ContactState = contactAdapter.getInitialState({
  selected_record_id: undefined 
}); 


export function ContactReducers(
  state: ContactState = initialState,
  action: actions.ContactActions
){
  switch(action.type){
    case actions.ContactActionTypes.UPDATE_SELECTED_ID:
      state = {...state,selected_record_id: action.selected_record_id};
      return state;

    case actions.ContactActionTypes.ADD_CONTACT: 
      return contactAdapter.addOne(action.contact, {...state,selected_record_id: state.selected_record_id});

    case actions.ContactActionTypes.ADD_CONTACTS:
      return contactAdapter.addMany(action.contacts,{...state,selected_record_id: state.selected_record_id});

    case actions.ContactActionTypes.UPSERT_CONTACT:
      return contactAdapter.upsertOne(action.contact,{...state,selected_record_id: state.selected_record_id});
      
    case actions.ContactActionTypes.UPSERT_CONTACTS:
      return contactAdapter.upsertMany(action.contacts,{...state,selected_record_id: state.selected_record_id});
  
    case actions.ContactActionTypes.UPDATE_CONTACT:
      return contactAdapter.updateOne({
        id: action.id,
        changes: action.changes
      },{...state,selected_record_id: state.selected_record_id});

    case actions.ContactActionTypes.UPDATE_CONTACTS:
      return contactAdapter.updateMany(action.updates,{...state,selected_record_id: state.selected_record_id});

    case actions.ContactActionTypes.DELETE_CONTACT:
      // if(state.selected_record_id == action.id){
      //   state.selected_record_id = undefined;
      // }
      return contactAdapter.removeOne(action.id,{...state,selected_record_id: state.selected_record_id});

    case actions.ContactActionTypes.DELETE_CONTACTS:
      // if(action.ids.indexOf(state.selected_record_id) > -1){
      //   state.selected_record_id = undefined;
      // }
      return contactAdapter.removeMany(action.ids,{...state,selected_record_id: state.selected_record_id});

    case actions.ContactActionTypes.DELETE_STATE:
      state.selected_record_id = undefined;
      return contactAdapter.removeAll(state);

    default:
      return state;
  }
}

export const getContactState = createFeatureSelector<ContactState>('contact');

const getSelectedContactIdState = (state: ContactState) => { 
  return state.selected_record_id
};
export const getSelectedContactId = createSelector(getContactState, getSelectedContactIdState);

export const getSelectedContact = createSelector(getContactState, (state: ContactState)=>{
  if(state.selected_record_id == undefined){
    return undefined;
  }
  return state.entities[state.selected_record_id];
})

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = contactAdapter.getSelectors(getContactState);